import { useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()

export const PRIMARY_ACCESS_TOKEN_KEY = 'premiss_primary_access_token'
export const PRIMARY_COMPANY_KEY = 'premiss_primary_company'
export const VISIT_DATA_TOKEN_KEY = 'premiss_user_data_user_token'
export const VISIT_DATA_PLATFORM_KEY = 'premiss_user_data_platform'
export const AUDIT_SESSION_ID_KEY = 'audit_session_id'

const VISIT_TOKEN_PREFIX = 'fyv1_'

export const isVisitToken = (token?: string): boolean => String(token || '').startsWith(VISIT_TOKEN_PREFIX)

export const rememberPrimaryAccessToken = (token?: string): void => {
  if (!token || isVisitToken(token)) return
  wsCache.set(PRIMARY_ACCESS_TOKEN_KEY, token)
}

export const rememberPrimaryCompany = (company: unknown): void => {
  if (!company) return
  wsCache.set(PRIMARY_COMPANY_KEY, company)
}

export const clearPrimaryAccessContext = (): void => {
  wsCache.delete(PRIMARY_ACCESS_TOKEN_KEY)
  wsCache.delete(PRIMARY_COMPANY_KEY)
}

export const restorePrimaryAccessContext = (clearAuditSession = true): boolean => {
  const token = wsCache.get(PRIMARY_ACCESS_TOKEN_KEY)
  if (!token) return false

  const changed = wsCache.get('access_token') !== token
  wsCache.set('access_token', token)

  const company = wsCache.get(PRIMARY_COMPANY_KEY)
  if (company) {
    wsCache.set('company', company)
  }

  if (clearAuditSession) {
    wsCache.delete(AUDIT_SESSION_ID_KEY)
  }
  return changed
}

export const mergeCompanyPlatform = (platform?: string): void => {
  if (!platform) return
  const companyCache = wsCache.get('company') || {}
  const companyData = companyCache.data && typeof companyCache.data === 'object' ? companyCache.data : {}
  const companyInfo = companyData.data && typeof companyData.data === 'object' ? companyData.data : {}
  wsCache.set('company', {
    ...companyCache,
    data: {
      ...companyData,
      data: {
        ...companyInfo,
        platform
      }
    }
  })
}

export const setVisitDataContext = (
  token: string,
  platform: string,
  sessionId?: string,
  useAsActiveToken = false
): boolean => {
  if (!token) return false

  const previousVisitToken = wsCache.get(VISIT_DATA_TOKEN_KEY)
  wsCache.set(VISIT_DATA_TOKEN_KEY, token)
  wsCache.set(VISIT_DATA_PLATFORM_KEY, platform || '')

  if (sessionId !== undefined) {
    if (sessionId) {
      wsCache.set(AUDIT_SESSION_ID_KEY, sessionId)
    } else {
      wsCache.delete(AUDIT_SESSION_ID_KEY)
    }
  } else if (previousVisitToken !== token) {
    wsCache.delete(AUDIT_SESSION_ID_KEY)
  }

  if (useAsActiveToken) {
    const changed = wsCache.get('access_token') !== token
    wsCache.set('access_token', token)
    mergeCompanyPlatform(platform)
    return changed || previousVisitToken !== token
  }

  return previousVisitToken !== token
}
